module.exports = __webpack_public_path__ + "static/media/flying-fish.bdb3dcb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/flying-fish.png
// module id = 310
// module chunks = 0